import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import * as Icon from "react-feather";

import * as d3 from "d3-dsv";
import { P } from "../../components/Texts";
import { DashboardHeader } from "../../components/Headers";
import { useHistory } from "react-router";

import VisualizerArea from "../../components/VisualizerArea";

import { dataSidebar, chartTypes } from "../../assets/Data/dataSidebar";

const ViewData = () => {
  const url = window.localStorage.getItem("datalabs_data_url");

  let history = useHistory();

  const goBack = () => history.goBack();

  const [chartType, setChartType] = useState("");
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState({});
  const [loading, setLoading] = useState(true);
  const [chartD, setChartD] = useState(null);

  useEffect(() => {
    const readDataFromUrl = async (url) => {
      setLoading(true);
      try {
        const res = await fetch(url);
        if (!res.ok) {
          setLoading(false);
          throw new Error("fetch failed");
        }
        // Clone the response
        const csvResponse = res.clone();
        const abResponse = res.clone();

        // Read the text from the first clone for CSV parsing
        const csvText = await csvResponse.text();

        // Read the array buffer from the second clone for Excel parsing
        const ab = await abResponse.arrayBuffer();

        // Parse CSV data
        const parsedData = d3.csvParse(csvText, (row) => inferTypes(row));
        setChartD(parsedData);

        // Parse Excel data
        const _data = new Uint8Array(ab);
        const wb = XLSX.read(_data, { type: "array" });

        // Get first worksheet
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        // Convert worksheet to JSON
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        // Set the files state
        const fileData = {
          name: "Howen.xlsx", // Adjust the name as needed
          table_data: data,
        };

        setFiles((prevFiles) => [...prevFiles, fileData]);
        setSelectedFile(fileData); // Set the selected file to the newly parsed data

        setLoading(false);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    readDataFromUrl(url);
  }, [url]);

  // Type inference function
  const inferTypes = (row) => {
    const parsedRow = {};

    Object.keys(row).forEach((key) => {
      const value = row[key];

      // Try to infer the type for each value
      if (!isNaN(value) && value.trim() !== "") {
        // If the value is a number, convert it to a number
        parsedRow[key] = +value;
      } else if (
        value.toLowerCase() === "true" ||
        value.toLowerCase() === "false"
      ) {
        // If the value is a boolean, convert to boolean
        parsedRow[key] = value.toLowerCase() === "true";
      } else {
        // Otherwise, leave it as a string
        parsedRow[key] = value;
      }
    });

    return parsedRow;
  };

  const [isChartPopupOpen, setIsChartPopupOpen] = useState(false);

  const handleItemClick = (action) => {
    if (action === "openChartPopup") {
      setIsChartPopupOpen(true);
    }
  };

  const handleChartSelect = (category, chartType) => {
    setIsChartPopupOpen(false);
    setChartType(chartType);
  };

  return (
    <section className="relative ">
      <DashboardHeader title="View Data" className="sticky top-0" />
      <section
        style={{
          height: "calc(100vh - 66px)",
        }}
        className="bg-white grid grid-cols-12"
      >
        {/* sidebar */}
        <div className="bg-white h-full col-span-1 pl-2 pt-4">
          <div
            className="mb-16 flex items-center cursor-pointer flex-shrink-0"
            onClick={goBack}
            style={{
              width: "fit-content",
              top: "66px",
            }}
          >
            <Icon.ChevronLeft size={18} color="#22202D" className="mr-2" />
            <P fontSize="14px" color="#22202D">
              Back
            </P>
          </div>

          <ul className="relative">
            {dataSidebar.map((item) => (
              <li key={item.id} className="mb-10">
                <button
                  onClick={() => handleItemClick(item.action)}
                  className="flex items-center w-full gap-x-2 rounded hover:bg-gray-200 transition-colors focus:outline-none focus:shadow-none focus:border-none"
                >
                  <img src={item.icon} alt={item.title} />
                  <span className="text-sm text-purple-3">{item.title}</span>
                </button>
              </li>
            ))}

            {isChartPopupOpen && (
              <div
                style={{
                  top: "0",
                  right: "-140px",
                  zIndex: "999",
                }}
                className="absolute bg-white p-3 shadow-md "
              >
                {Object.entries(chartTypes).map(([category, charts]) => (
                  <div key={category} className="mb-10">
                    <span className="w-full text-xs">{category}</span>

                    <div className="w-40 mt-2 px-8">
                      {charts.map((chart) => (
                        <button
                          key={chart.id}
                          onClick={() =>
                            handleChartSelect(chart.category, chart.id)
                          }
                          className="flex items-center gap-x-2 text-xs mb-4  text-black hover:bg-gray-200"
                        >
                          <img src={chart.icon} alt={chart.name} />
                          <span className="text-xs"> {chart.name}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ul>
        </div>

        {/* chart aread */}
        <VisualizerArea
          chartType={chartType}
          files={files}
          selectedFile={selectedFile}
          loading={loading}
          chartData={chartD}
          setChartType={setChartType}
        />
      </section>
    </section>
  );
};

export default ViewData;
